import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import {makeStyles} from '@material-ui/core/styles';
import {Route, Switch, useLocation} from 'react-router-dom';
import GoogleAnalytics from "react-ga";
import clsx from "clsx";
import Confetti from 'react-confetti'

import {DialogTerms, ViewTerms} from "../views/ViewTerms";
import {DrawerItems} from "../components/DrawerItems";
import {Footer} from "../components/Footer";
import {LocalStorageKeys, usePersistedState} from "../logic/Persistence";
import {TopBar} from "../components/TopBar";
import {ViewAbout} from "../views/ViewAbout";
import {ViewAdminQueues} from "../views/ViewAdminQueues";
import {ViewChatsList} from "../views/ViewChatsList";
import {ViewChat} from "../views/ViewChat";
import {ViewTweetQueue} from "../views/ViewTweetQueue";
import {getFourPointPlanRoutes} from "../views/ViewFourPointPlan";


// Analytics
GoogleAnalytics.initialize('UA-65634159-6', {debug: false});

function Analytics() {
  const location = useLocation();
  React.useEffect(() => {
    GoogleAnalytics.pageview(window.location.pathname + window.location.search);
  }, [location]);
  return <React.Fragment/>
}

// Custom Confetti
const OurConfetti = ({onDone}) => <Confetti
  recycle={false} onConfettiComplete={onDone}
  drawShape={(ctx) => ctx.fillRect(-20, -20, 40, 40)}
  style={{position: 'fixed'}}/>;

const useLocalStyles = makeStyles(theme => ({
  fullHeight: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  root: {
    background: 'inherit',
    // transition: "background 1000ms cubic-bezier(0.34, 1.61, 0.7, 1)",
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  rootTermsNotAccepted: {
    // background: 'rgb(154, 146, 155)',
  },
  drawerPanel: {
    width: 300,
  },
  main: {},
  appBarSpacer: theme.mixins.toolbar,
  footerSpacer: theme.mixins.toolbar,
}));

export default function AppLayout() {
  const classes = useLocalStyles();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [termsAccepted, setTermsAccepted] = usePersistedState(LocalStorageKeys.accepted_terms, false);
  const [showConfetti, setShowConfetti] = React.useState(true);
  const showDrawer = () => setDrawerOpen(true);
  const hideDrawer = () => setDrawerOpen(false);
  const onTermsAccepted = () => {
    setShowConfetti(true);
    setTermsAccepted(true)
  };
  return (
    <div className={clsx(classes.root, termsAccepted ? '' : classes.rootTermsNotAccepted, classes.fullHeight)}>
      <TopBar onOpenDrawer={showDrawer}/>
      <Analytics/>
      <Drawer open={drawerOpen} onClose={hideDrawer}>
        <div className={classes.drawerPanel} role="presentation" onClick={hideDrawer} onKeyDown={hideDrawer}>
          <DrawerItems/>
        </div>
      </Drawer>
      <main className={clsx(classes.main, classes.fullHeight)}>
        {showConfetti && termsAccepted && <OurConfetti onDone={() => setShowConfetti(false)}/>}
        <div className={classes.appBarSpacer}/>
        {!termsAccepted ? <DialogTerms onAccept={onTermsAccepted}/> :
          <Switch>
            {/*<Route path='/chat/new' component={ViewNotImplemented}/>*/}
            <Route path='/chat/:id' component={ViewChat}/>
            {/*<Route path='/story/fork/:sid' component={ViewNotImplemented}/>*/}
            {/*<Route path='/story/:sid' component={ViewNotImplemented}/>*/}
            <Route path='/about' component={ViewAbout}/>
            {/*<Route path='/replica' component={ViewNotImplemented}/>*/}
            <Route path='/terms' component={ViewTerms}/>
            {/*<Route path='/queue/:qid' component={ViewTweetQueue}/>*/}
            <Route path='/queue/twitter-next' component={ViewTweetQueue}/>
            <Route path='/admin-queues' component={ViewAdminQueues}/>
            {getFourPointPlanRoutes()}
            <Route path='/' component={ViewChatsList}/>
          </Switch>}
        <div className={classes.footerSpacer}/>
      </main>
      <Footer/>
    </div>
  );
}
